export default __webpack_public_path__ + "static/chart-customisation-223de56740ce306709ca3e4408a91fde.png";